// extracted by mini-css-extract-plugin
export default {"caption":"buttons_caption__sT3bC","buttonsGroup":"buttons_buttonsGroup__YCtlU"};